export enum PardotTypeRoutePart {
	AutomationRule = 'automations',
	Email = 'emails',
	EmailTemplate = 'email-templates',
	Field = 'fields',
	Form = 'forms',
	LandingPage = 'landing-pages',
	List = 'lists',
	Object = 'objects',
	PageAction = 'page-actions',
	Profile = 'profiles'
}

export enum SalesforceTypeRoutePart {
	ApexClass = 'sfApexClasses',
	ApexTrigger = 'sfApexTriggers',
	EmailTemplate = 'email-templates',
	Entity = 'entity-definitions',
	Field = 'fields',
	FieldUpdate = 'field-updates',
	Flow = 'flows',
	PageLayout = 'page-layouts',
	Profile = 'profiles',
	PicklistValue = 'sfPicklistValues',
	ProcessBuilder = 'flows',
	Report = 'sfReports',
	ValidationRule = 'validation-rules',
	EmailAlert = 'workflow-alerts',
	WorkflowRule = 'workflow-rules'
}
